import { API } from 'src/utils/AmplifyApiUtils';
import { IntakeForm, IntakeFormResponse } from 'src/store/intake_forms/types';

export default class IntakeFormsClient {
  static LoadIntakeForm(): Promise<IntakeForm[]> {
    return API.get('AppAPI', '/entities/intake-forms?includeDetails=true', {});
  }

  static SaveIntakeForm(form: IntakeForm): Promise<IntakeForm[]> {
    return API.post('AppAPI', '/entities/intake-forms?includeDetails=true', {
      body: {
        data: [form],
      },
    });
  }

  static SendIntakeForm(params: {
    clientsIds: string[];
    formId: string;
  }): Promise<IntakeForm[]> {
    return API.post('AppAPI', '/entities/intake-form-responses', {
      body: {
        clientsIds: params.clientsIds,
        formId: params.formId,
      },
    });
  }

  static DuplicateForm(params: {
    name: string;
    formId: string;
  }): Promise<IntakeForm[]> {
    return API.post('AppAPI', '/intake-forms/duplicate', {
      body: {
        name: params.name,
        formId: params.formId,
      },
    });
  }

  static UpdateIntakeForm(form: IntakeForm): Promise<IntakeForm[]> {
    return API.put('AppAPI', '/entities/intake-forms?includeDetails=true', {
      body: {
        data: [form],
      },
    });
  }

  static LoadIntakeInputs(): Promise<IntakeForm[]> {
    return API.get('AppAPI', '/entities/intake-inputs', {});
  }

  static GetIntakeFormResponseChannels(
    formId: string,
  ): Promise<IntakeFormResponse[]> {
    return API.get(
      'AppAPI',
      `/entities/intake-form-responses?formId=${formId}`,
      {},
    );
  }

  static GetIntakeFormResponseByUserId(
    userId: string,
  ): Promise<IntakeFormResponse[]> {
    const urlEncodedUserId = encodeURIComponent(userId).replace(/%20/g, '%2B');
    return API.get(
      'AppAPI',
      `/entities/intake-form-responses?userId=${urlEncodedUserId}`,
      {},
    );
  }

  static LoadIntakeFormResponses(): Promise<IntakeForm[]> {
    return API.get('AppAPI', '/entities/intake-form-responses', {});
  }

  static UpdateIntakeFormResponses(
    formResponses: IntakeFormResponse,
  ): Promise<IntakeFormResponse[]> {
    return API.put('AppAPI', '/entities/intake-form-responses', {
      body: {
        data: [formResponses],
      },
    });
  }

  static DeleteIntakeForm(form: IntakeForm): Promise<IntakeForm[]> {
    return API.del('AppAPI', '/entities/intake-forms', {
      body: {
        data: [form],
      },
    });
  }
}
